import { cos } from './cos'
import { folder } from './folder'
import { material } from './material'
import { tag } from './tag'
import { user } from './user'
import { workspace } from './workspace'

export const api = {
  user,
  folder,
  tag,
  material,
  cos,
  workspace,
}
